import React, { Component, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";
import FilterSearchSection from "../component/section/filtersearch";
import WidgetLikeSection from "../component/section/widgetlike";
import WidgetGroupSection from "../component/section/widgetgroup";
import AllPhotos from "../component/section/photos";
import GroupItemTwo from "../component/items/groupitemtwo";
import axios from "axios";
import { FiCheck, FiEdit } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { input } from "@testing-library/user-event/dist/cjs/event/input.js";
import { UserRoleOptions } from "../constants/userRole";
import { toast } from "react-toastify";
import GroupItemThree from "../component/items/groupitemthree";
import { SyncLoader } from "react-spinners";
import { convertImageToWebP } from "../utils/convertToWebp";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const GalleryPage = () => {
  const [images, setImages] = useState([]);
  const fileInputRef = useRef(null);
  const [isUploadingImage, setIsUploadingImage] = useState(false);

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const token = localStorage.getItem("token");

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const observer = useRef();

  const fetchImages = React.useCallback(async (pageToFetch = 1) => {
    if (pageToFetch > 1) setLoadingMore(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_MAIN_SITE_URL}/gallery?page=${pageToFetch}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const response = res.data;
      let newData = [];
      if (Array.isArray(response)) {
        newData = response;
      } else if (response && Array.isArray(response.data)) {
        newData = response.data;
      }

      if (pageToFetch === 1) {
        setImages(newData);
      } else {
        setImages((prev) => {
          const existingIds = new Set(prev.map(img => img.id));
          const uniqueNewData = newData.filter(img => !existingIds.has(img.id));
          return [...prev, ...uniqueNewData];
        });
      }

      if (response && response.last_page !== undefined) {
          setHasMore(response.current_page < response.last_page);
      } else {
          setHasMore(false);
      }
    } catch (err) {
      console.error("Error fetching gallery:", err);
      if (pageToFetch === 1) setImages([]);
    } finally {
      if (pageToFetch > 1) setLoadingMore(false);
    }
  }, [token]);

  const lastElementRef = React.useCallback(
    (node) => {
      if (loadingMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => {
            const nextPage = prevPage + 1;
            fetchImages(nextPage);
            return nextPage;
          });
        }
      });

      if (node) observer.current.observe(node);
    },
    [loadingMore, hasMore, fetchImages]
  );

  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files);

    setIsUploadingImage(true);

    for (let file of files) {
      try {
        // Convert to webp (already in your utils)
        const webpBlob = await convertImageToWebP(file);
        const webpFile = new File([webpBlob], "image.webp", {
          type: "image/webp",
        });

        // upload to bucket (you already do this)
        const formData = new FormData();
        formData.append("image", webpFile);

        const bucketRes = await axios.post(
          `${process.env.REACT_APP_MAIN_SITE_URL}/upload-image`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        const bucketUrl = bucketRes.data.data.url;

        // now save URL to Laravel DB
        const res = await axios.post(
          `${process.env.REACT_APP_MAIN_SITE_URL}/gallery/upload`,
          { url: bucketUrl },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setImages((prev) => [res.data.data, ...prev]);
        toast.success("Image uploaded!");

        setIsUploadingImage(false);
      } catch (err) {
        console.error(err);
        toast.error("Upload failed!");
      }
    }
  };

  useEffect(() => {
    fetchImages(1);
  }, [fetchImages]);

  const removeImage = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };



  const handleDelete = async (id) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/gallery/delete`,
        { id },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setImages((prev) => prev.filter((img) => img.id !== id));
      toast.success("Image deleted!");
    } catch (err) {
      toast.error("Delete failed!");
    }
  };

  const handleImageClick = (index) => {
    setPhotoIndex(index);
    setLightboxOpen(true);
  };

  return (
    <div>
      <Header />
      <PageHeader title={"Gallery"} />
      <section className="profile-section padding-tb">
        <div className="container">
          <div className="section-wrapper">
            <div className="member-profile">
              <div className="profile-details">
                {/*                 
                <nav className="profile-nav">
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      className="nav-link"
                      id="nav-photos-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#photos"
                      type="button"
                      role="tab"
                      aria-controls="photos"
                      aria-selected="false"
                    >
                      Photos
                    </button>
                    <button
                      className="nav-link active" 
                      id="nav-media-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#media"
                      type="button"
                      role="tab"
                      aria-controls="media"
                      aria-selected="true" // 👈 set true
                    >
                      Media <span className="item-number">35</span>
                    </button>

                    <div className="dropdown">
                      <a
                        className="btn dropdown-toggle"
                        href="#"
                        role="button"
                        id="dropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        More
                      </a>

                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuLink"
                      >
                        <li>
                          <a className="dropdown-item" href="#">
                            Activity
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            Privacy
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            Block user
                          </a>
                        </li>
                      </ul>
                    </div>


                  </div>
                </nav> */}

                {isUploadingImage && (
                  <div className="fullscreen-loader d-flex justify-content-center align-items-center">
                    <SyncLoader size={12} color="#DF314D" />
                  </div>
                )}

                <div className="tab-content" id="nav-tabContent">
                  <div
                    className="tab-pane activity-page fade show active"
                    id="activity"
                    role="tabpanel"
                  ></div>

                  <div
                    className="tab-pane fade"
                    id="groups"
                    role="tabpanel"
                    aria-labelledby="nav-groups-tab"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8"></div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            {/* <WidgetGroupSection
                              groupList={groupList}
                              loading={loadingGroups}
                            /> */}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="photos"
                    role="tabpanel"
                    aria-labelledby="nav-photos-tab"
                  >
                    <AllPhotos />
                  </div>
                  <div
                    className="tab-pane fade show active"
                    id="media"
                    role="tabpanel"
                    aria-labelledby="nav-media-tab"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8">
                          <article>
                            <div className="media-wrapper">
                              <ul
                                className="nav nav-tabs"
                                id="myTab"
                                role="tablist"
                              >
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link active"
                                    id="all-media-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#all-media"
                                    type="button"
                                    role="tab"
                                    aria-controls="all-media"
                                    aria-selected="true"
                                  >
                                    <i className="icofont-star"></i> All Media
                                  </button>
                                </li>
                                {/* <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="album-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#album"
                                    type="button"
                                    role="tab"
                                    aria-controls="album"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-layout"></i> Albums
                                    <span>04</span>
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="photos-media-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#photos-media"
                                    type="button"
                                    role="tab"
                                    aria-controls="photos-media"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-image"></i>
                                    Photos <span>12</span>
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="video-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#video"
                                    type="button"
                                    role="tab"
                                    aria-controls="video"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-video-alt"></i> Videos
                                    <span>0</span>
                                  </button>
                                </li> */}
                                {/* <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="music-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#music"
                                    type="button"
                                    role="tab"
                                    aria-controls="music"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-music-disk"></i> Music
                                    <span>0</span>
                                  </button>
                                </li> */}
                              </ul>

                              <div className="tab-content" id="myTabContent">
                                <div
                                  className="tab-pane fade show active"
                                  id="all-media"
                                  role="tabpanel"
                                  aria-labelledby="all-media-tab"
                                >
                                  <div className="media-title">
                                    <h3>Media Gallery</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input
                                            type="file"
                                            accept="image/*"
                                            multiple
                                            onChange={handleImageUpload}
                                            ref={fileInputRef}
                                          />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-4 g-3">
                                      {images.map((img, index) => (
                                        <div className="col" key={img.id}>
                                          <div className="media-thumb position-relative">
                                            <img
                                              src={img.url}
                                              alt="user upload"
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                handleImageClick(index)
                                              }
                                            />

                                            {img.user_id ===
                                              Number(
                                                localStorage.getItem("user_id")
                                              ) && (
                                              <button
                                                className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                                                onClick={() =>
                                                  handleDelete(img.id)
                                                }
                                              >
                                                <i className="icofont-ui-delete"></i>
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </div>

                                    {lightboxOpen && images[photoIndex] && (
                                      <Lightbox
                                        mainSrc={images[photoIndex].url}
                                        nextSrc={
                                          images[
                                            (photoIndex + 1) % images.length
                                          ]?.url
                                        }
                                        prevSrc={
                                          images[
                                            (photoIndex + images.length - 1) %
                                              images.length
                                          ]?.url
                                        }
                                        onCloseRequest={() =>
                                          setLightboxOpen(false)
                                        }
                                        onMovePrevRequest={() =>
                                          setPhotoIndex(
                                            (photoIndex + images.length - 1) %
                                              images.length
                                          )
                                        }
                                        onMoveNextRequest={() =>
                                          setPhotoIndex(
                                            (photoIndex + 1) % images.length
                                          )
                                        }
                                      />
                                    )}

                                    {hasMore && (
                                      <div ref={lastElementRef} className="load-btn text-center my-4">
                                        {loadingMore && (
                                          <SyncLoader size={10} color="#DF314D" />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="album"
                                  role="tabpanel"
                                  aria-labelledby="album-tab"
                                >
                                  <div className="media-title">
                                    <h3>Album Lists</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row g-4">
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/02.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Private</h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/03.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Crush</h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/06.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Public</h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/08.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Favorite</h6>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="load-btn">
                                      <a href="#" className="lab-btn">
                                        Load More
                                        <i className="icofont-spinner"></i>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="photos-media"
                                  role="tabpanel"
                                  aria-labelledby="photos-media-tab"
                                >
                                  <div className="media-title">
                                    <h2>All Photos</h2>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-4 g-3">
                                      <div className="col">
                                        <div className="media-thumb">
                                          {/*                                           
                                          <img
                                            src="assets/images/member/01.jpg"
                                            alt="img"
                                          /> */}
                                        </div>
                                      </div>

                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/02.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    {hasMore && (
                                      <div className="load-btn">
                                        <button
                                          className="lab-btn"
                                          onClick={() => {
                                            const nextPage = page + 1;
                                            setPage(nextPage);
                                            fetchImages(nextPage);
                                          }}
                                        >
                                          See More{" "}
                                          <i className="icofont-spinner"></i>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="video"
                                  role="tabpanel"
                                  aria-labelledby="video-tab"
                                >
                                  <div className="media-title">
                                    <h3>All Videos</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row">
                                      <div className="col">
                                        <p>
                                          <i className="icofont-worried"></i>{" "}
                                          Sorry !! There's no media found for
                                          the request !!{" "}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="load-btn">
                                      <a href="#" className="lab-btn">
                                        See More
                                        <i className="icofont-spinner"></i>
                                      </a>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="music"
                                  role="tabpanel"
                                  aria-labelledby="music-tab"
                                >
                                  <div className="media-title">
                                    <h3>All Music</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row">
                                      <div className="col">
                                        <p>
                                          <i className="icofont-worried"></i>{" "}
                                          Sorry !! There's no media found for
                                          the request !!{" "}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="load-btn">
                                      <a href="#" className="lab-btn">
                                        See More
                                        <i className="icofont-spinner"></i>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            {/* <WidgetGroupSection
                              groupList={groupList}
                              loading={loadingGroups}
                            /> */}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterSection />
    </div>
  );
};

export default GalleryPage;
